import { render, staticRenderFns } from "./AskPasswordForm.vue?vue&type=template&id=4cc816c2&"
import script from "./AskPasswordForm.vue?vue&type=script&lang=js&"
export * from "./AskPasswordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports